import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { useTranslation } from "react-i18next";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import sidebar from "../../utils/sidebar";
import { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PageSubHeader from "../../../../components/Layouts/PageSubHeader";
import PersonalTab from "./Tabs/Personal";
import FixedSave from "../../../../components/Actions/FixedSave";
import ContractTab from "./Tabs/Contract";
import TimeManagementTab from "./Tabs/TimeManagment";
import PayrollTab from "./Tabs/Payroll";
import { toast } from "react-toastify";
import { format } from "date-fns";
import { post } from "../../../../utils/helpers/api";
import JobInfosTab from "./Tabs/JobInfos";
import WorkExperienceTab from "./Tabs/WorkExperience";

function CreateEmployeePage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { state } = useLocation();
  const { id } = useParams();
  const isNew = !id;
  const [activeTab, setActiveTab] = useState(1);
  const [saveLoading, setSaveLoading] = useState(false);
  const [employeeData, setEmployeeData] = useState({
    firstname: state?.employeeData?.firstname || '',
    middlename: state?.employeeData?.middlename || '',
    lastname: state?.employeeData?.lastname || '',
    gender: state?.employeeData?.gender || '',
    birthdate: state?.employeeData?.birthdate || '',
    marital_status: state?.employeeData?.marital_status || '',
    blood_group: state?.employeeData?.blood_group || '',
    id_type: state?.employeeData?.id_type || '',
    id_number: state?.employeeData?.id_number || '',
    id_issue_date: state?.employeeData?.id_issue_date || '',
    id_expiry_date: state?.employeeData?.id_expiry_date || '',
    address: state?.employeeData?.address || '',
    city: state?.employeeData?.city || '',
    state: state?.employeeData?.state || '',
    postal_code: state?.employeeData?.postal_code || '',
    country: state?.employeeData?.country || '',
    country_code: state?.employeeData?.country_code || '',
    phone_number: state?.employeeData?.phone_number || '',
    email: state?.employeeData?.email || '',
    emergency_contact_name: state?.employeeData?.emergency_contact_name || '',
    emergency_contact_country_code: state?.employeeData?.emergency_contact_country_code || '',
    emergency_contact_phone_number: state?.employeeData?.emergency_contact_phone_number || '',
    contract_type: state?.employeeData?.contract_type || 'cdd',
    contract_start_date: state?.employeeData?.contract_start_date || '',
    contract_end_date: state?.employeeData?.contract_end_date || '',
    work_schedule: state?.employeeData?.work_schedule || '',
    weekly_working_hours: state?.employeeData?.weekly_working_hours || '',

    job_title: state?.employeeData?.job_title || '',
    department: state?.employeeData?.department || '',
    position: state?.employeeData?.position || '',
    employment_status: state?.employeeData?.employment_status || 'active',
    termination_date: state?.employeeData?.termination_date || '',
    termination_reason: state?.employeeData?.termination_reason || '',

    shift_hours: state?.employeeData?.shift_hours || '',
    salary_frequency: state?.employeeData?.salary_frequency || '',
    overtime_allowed: state?.employeeData?.overtime_allowed || false,
    overtime_rate: state?.employeeData?.overtime_rate || '',
    salary_amount: state?.employeeData?.salary_amount || '',
    payment_method: state?.employeeData?.payment_method || '',
    bank_name: state?.employeeData?.bank_name || '',
    bank_account_number: state?.employeeData?.bank_account_number || '',
    bank_routing_iban: state?.employeeData?.bank_routing_iban || '',
    social_security_number: state?.employeeData?.social_security_number || '',

    work_experiences: state?.employeeData?.work_experiences || [],
    educations: state?.employeeData?.educations || [],
    benefits: state?.employeeData?.benefits || [],
  });

  // Convert a DatePicker value (Date object) to a MySQL-friendly `YYYY-MM-DD`
  // string using local date components, so the day the user picked is preserved
  // (slicing the ISO string would shift the day in non-UTC timezones).
  const toDateString = (value) => (value ? format(new Date(value), 'yyyy-MM-dd') : null);

  const saveEmployee = async () => {
    setSaveLoading(true);
    const payload = {
      ...employeeData,
      birthdate: toDateString(employeeData.birthdate),
      id_issue_date: toDateString(employeeData.id_issue_date),
      id_expiry_date: toDateString(employeeData.id_expiry_date),
      contract_start_date: toDateString(employeeData.contract_start_date),
      contract_end_date: toDateString(employeeData.contract_end_date),
      termination_date: toDateString(employeeData.termination_date),
      work_experiences: (employeeData.work_experiences || []).map((row) => ({
        ...row,
        start_date: toDateString(row.start_date),
        end_date: toDateString(row.end_date),
      })),
      educations: (employeeData.educations || []).map((row) => ({
        ...row,
        date_of_completion: toDateString(row.date_of_completion),
      })),
      benefits: (employeeData.benefits || []).map((row) => ({
        benefit_type_id: row.benefit_type_id,
        calculation_type: row.calculation_type,
        value: Number(row.value) || 0,
        percentage_base: row.percentage_base,
        effective_from: toDateString(row.effective_from),
        effective_to: toDateString(row.effective_to),
      })),
    };
    const url = isNew ? '/hr/employees/store' : `/hr/employees/update/${id}`;
    const data = await post(url, payload);
    if(data.success) {
      navigate('/hr/employees');
    } else {
      toast.error(t('common.errorOccurred'));
    }
    setSaveLoading(false);
  }

  return(
    <SidebarLayout sidebar={sidebar}>
      <div className="page-with-subheader">
        <PageSubHeader
          breadcrumb={[t('hr.employees'), t('common.new') + ' ' + t('hr.employees')]}
          onBack={() => navigate('/hr/employees')}
        />
        <div className="subheader-page-content scrollable">
          <Nav tabs>
            <NavItem>
              <NavLink
                active={activeTab === 1}
                onClick={() => setActiveTab(1)}
              >
                {t('hr.personalInfos')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                active={activeTab === 2}
                onClick={() => setActiveTab(2)}
              >
                {t('hr.contractInfos')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                active={activeTab === 3}
                onClick={() => setActiveTab(3)}
              >
                Job & Org Infos
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                active={activeTab === 4}
                onClick={() => setActiveTab(4)}
              >
                {t('hr.timeManagement')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                active={activeTab === 5}
                onClick={() => setActiveTab(5)}
              >
                {t('hr.payrollInfos')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                active={activeTab === 6}
                onClick={() => setActiveTab(6)}
              >
                Work Experience
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab}>
            <TabPane tabId={1}>
              <PersonalTab employeeData={employeeData} setEmployeeData={setEmployeeData} />
            </TabPane>

            <TabPane tabId={2}>
              <ContractTab employeeData={employeeData} setEmployeeData={setEmployeeData} />
            </TabPane>

            <TabPane tabId={3}>
              <JobInfosTab employeeData={employeeData} setEmployeeData={setEmployeeData} />
            </TabPane>

            <TabPane tabId={4}>
              <TimeManagementTab employeeData={employeeData} setEmployeeData={setEmployeeData} />
            </TabPane>

            <TabPane tabId={5}>
              <PayrollTab employeeData={employeeData} setEmployeeData={setEmployeeData} />
            </TabPane>

            <TabPane tabId={6}>
              <WorkExperienceTab employeeData={employeeData} setEmployeeData={setEmployeeData} />
            </TabPane>
          </TabContent>
        </div>
      </div>

      <FixedSave 
        onSave={saveEmployee} 
        loading={saveLoading}
        disabled={!employeeData.firstname || !employeeData.lastname || saveLoading}
      />
    </SidebarLayout>
  );
}

export default CreateEmployeePage;
